import { render, staticRenderFns } from "./global-seach-field.vue?vue&type=template&id=35df92b8&scoped=true&"
import script from "./global-seach-field.vue?vue&type=script&lang=js&"
export * from "./global-seach-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35df92b8",
  null
  
)

export default component.exports